<template>
  <div v-if="tip && content" :title="localContent">
    <span v-if="$slots.default" class="word-break">
      <slot></slot>
    </span>
    <span v-else class="word-break">{{ localContent || '' }}</span>
  </div>
  <!-- <el-tooltip v-if="tip && content" class="item" effect="light" :content="localContent || ''" placement="top-start">
    <span v-if="$slots.default" class="word-break">
      <slot></slot>
    </span>
    <span v-else class="word-break">{{ localContent || '' }}</span>
  </el-tooltip> -->
  <div v-else-if="localContent">
    <span v-if="$slots.default" class="word-break">
      <slot></slot>
    </span>
    <span v-else class="word-break">{{ localContent || '' }}</span>
  </div>
  <span v-else>-</span>
</template>

<script>
export default {
  props: {
    content: String,
    tip: {
      type: Boolean,
      default: true
    },
    separator: {
      type: String,
      default: ','
    }
  },
  data () {
    return {
      localContent: null
    }
  },
  watch: {
    content: {
      deep: true,
      immediate: true,
      handler () {
        this.localContent = this.content ? this.content.replace(/,/g, '，') : ''
      }
    }
  }
}
</script>

<style scoped>
.word-break {
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>


// WEBPACK FOOTER //
// src/components/business/TableCellWordBreak.vue